export interface EmployeeInsurance {
  id: number;
  createdAt: string;
  updatedAt: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy: CreatedBy;
  siBookNumber: string;
  siStartMonth: number;
  siEndMonth: number;
  siAgencies?: string;
  siStatus: string;
  siRefUrl?: string;
  hiCardNumber: string;
  hiHospitalCode: string;
  hiHospitalName: string;
  hiRefUrl?: string;
  empRegion: string;
  empPosition: string;
  empPositionStartDate: string;
  empPositionEndDate: string;
  hazardousStartDate: string;
  hazardousEndDate: string;
  siMethodCode: string;
  siMethodName: string;
  siNote: string;
  countryId?: number;
  ethnicityId?: number;
  employeeId: number;
  organizationId: number;
  country?: Country;
  ethnicity?: Country;
}

interface Country {
  id: number;
  name: string;
  nativeName: string;
  code: string;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface EmployeeInsuranceListRequest {
  employeeId: number;
}

export interface EmployeeInsuranceCreateRequest {
  employeeId: number;
  siBookNumber: string;
  siStartMonth?: string;
  siEndMonth?: string;
  siAgencies?: string;
  siStatus: string;
  siRefUrl?: string;
  hiCardNumber?: string;
  hiHospitalCode?: string;
  hiHospitalName?: string;
  hiRefUrl?: string;

  empRegion?: string;
  empPosition?: string;
  empPositionStartDate?: string;
  empPositionEndDate?: string;
  hazardousStartDate?: string;
  hazardousEndDate?: string;
  siMethodCode?: string;
  siMethodName?: string;
  siNote?: string;
  countryId?: number;
  ethnicityId?: number;
}

export type EmployeeInsuranceUpdateRequest = EmployeeInsuranceCreateRequest;

export interface EmployeeInsuranceListResponse extends RestAPIMetaResponse {
  items: Array<EmployeeInsurance>;
}

export enum EmployeeInsuranceSIStatus {
  Lost = "Lost",
  Kept = "Kept",
  None = "None",
}

export enum EmployeeInsuranceRegion {
  R1 = "R1",
  R2 = "R2",
  R3 = "R3",
}
